import React from 'react'
import styled, { css } from 'styled-components'
import { Card } from './Card'

export const UpsellCard = ({ children, ...rest }) => {
  return <Root {...rest}>{children}</Root>
}

const Root = styled(Card)`
  margin-top: ${({ hasError }) => (hasError ? 24 : 40)}px;
  padding: 48px 64px;

  ${({ isLoading }) =>
    isLoading &&
    css`
      min-height: 500px;

      @media (max-width: 639px) {
        min-height: 100%;
      }
    `}

  @media (max-width: 639px) {
    margin-top: 24px;
    padding: 24px 32px;
  }
`
